
    <ng-container [ngSwitch]="layout">
      <ng-container *ngSwitchCase="'table'">
        <div
          class="firmware-generic-widget mb-3"
          [ngClass]="{
            'div-table-tr': options?.index % 2 == 1,
            'div-table-tr-alt': options?.index % 2 == 0
          }"
        >
          <div
            class="row align-items-center"
            (click)="showEditModal(defaultView, entity, $event)"
          >
            <div class="col text-left py-2">
              <a class="btn btn-link" href="#" role="button"
                >#{{ entity?.identifier }}</a
              >
            </div>
            <div class="col text-left py-2">{{ entity?.name }}</div>
            <div class="col text-left py-2">
              <b
                class="btn-pill pl-2 pr-2"
                [ngClass]="{
                  'bg-success':
                    entity.status == 'approved' || entity.status == 'managed',
                  'bg-danger': entity.status == 'pending'
                }"
              >
                {{ entity?.status || "Pending" }}
              </b>
            </div>
            <div class="col text-left py-2">
              {{ firmwareName(entity?.firmware) }}
            </div>
            <div *ngIf="!options?.edit" class="col text-left py-2">
              <embed-firmware-target
                [entity]="entity.target"
                [layout]="'mini'"
                [options]="options"
              ></embed-firmware-target>
            </div>

            <div *ngIf="options?.edit" class="col text-left py-2">
              <embed-firmware-target
                [entity]="entity.target"
                [layout]="'mini'"
                [options]="getOptionsWithoutEdit(options)"
              ></embed-firmware-target>
            </div>
            <div class="col text-left py-2">
              {{ entity?.approval || "Pending" }}
            </div>
          </div>
        </div>
      </ng-container>
      <div class="firmware-generic-widget mb-3" *ngSwitchCase="'shadowbox'">
        <ng-container *ngTemplateOutlet="defaultView"></ng-container>
      </div>
      <div class="firmware-generic-widget mb-3" *ngSwitchCase="'modal'">
        <ng-container *ngTemplateOutlet="defaultView"></ng-container>
      </div>
      <div class="firmware-generic-widget mb-3" *ngSwitchDefault>
        <div class="card m-0">
          <div class="card-header bg-dark text-white p-2">
            #{{ entity?.identifier }}
          </div>
          <div class="card-body p-2">
            <ng-container *ngTemplateOutlet="defaultView"></ng-container>
          </div>
          <div
            class="card-footer p-2"
            *ngIf="
              options.edit &&
              !options?.modal_form &&
              (showApproveForm() || entity?.pending)
            "
          >
            <div class="row">
              <div class="col-4">
                <button
                  *ngIf="entity?.pending"
                  (click)="saveLink(linkModal, $event)"
                  class="btn btn-success btn-block"
                  type="submit"
                >
                  <i class="fa fa-plus-circle"></i> Save Changes
                </button>
              </div>
              <div class="col-4">
                <button
                  *ngIf="showApprove()"
                  (click)="approveLink(linkModal, $event)"
                  class="btn btn-primary btn-block"
                >
                  Approve
                </button>
              </div>
              <div class="col-4">
                <button
                  *ngIf="entity?.userMayDelete()"
                  (click)="deleteLink(linkModal, $event)"
                  class="btn btn-warning btn-block"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #defaultView>
      <!-- Modal Header -->
      <div
        class="modal-header bg-light d-flex justify-content-between align-items-center py-3"
      >
        <h4 class="modal-title m-0 h5 font-weight-bold">
          {{ currentModal?.title }}
        </h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="currentModal?.cancel()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="container-fluid">
          <!-- Basic Info -->
          <div class="row mb-3">
            <div class="col-md-4 d-flex align-items-center">
              <label class="font-weight-bold mr-2 mb-0">Identifier:</label>
              <div class="form-control-plaintext mb-0">
                {{ entity.identifier || "New" }}
              </div>
            </div>
            <div class="col-md-4 d-flex align-items-center">
              <label class="font-weight-bold mr-2 mb-0">Status:</label>
              <div
                class="form-control-plaintext mb-0"
                [ngClass]="{
                  'text-success': entity.status === 'approved',
                  'text-danger': entity.status !== 'approved'
                }"
              >
                {{ entity.status || "Pending" }}
              </div>
            </div>
            <!-- Release -->
            <div class="col-md-4 d-flex align-items-center">
              <label class="font-weight-bold mr-2 mb-0">Release:</label>
              <div class="form-control-plaintext mb-0">
                {{ entity.release || "Null" }}
              </div>
            </div>
          </div>

          <!-- Name -->
          <div class="mb-3">
            <label class="font-weight-bold">Name</label>
            <div *ngIf="!options?.edit" class="form-control-plaintext">
              {{ entity.name }}
            </div>
            <input
              *ngIf="options?.edit"
              type="text"
              class="form-control"
              [(ngModel)]="entity.name"
              (ngModelChange)="updateDefinition()"
            />
          </div>

          <div class="row mb-3">
            <!-- Approval -->
            <div class="col-md-6 d-flex align-items-center">
              <label class="font-weight-bold mr-2 mb-0">Approval:</label>
              <div class="form-control-plaintext mb-0">
                {{ entity.approval || "Pending" }}
              </div>
            </div>

            <!-- Final Approval -->
            <div class="col-md-6 d-flex align-items-center">
              <label class="font-weight-bold mr-2 mb-0">Final Approval:</label>
              <div class="form-control-plaintext mb-0">
                {{ entity.finalization || "Pending" }}
              </div>
            </div>
          </div>

          <!-- Firmware -->
          <div class="mb-3">
            <label class="font-weight-bold">Firmware</label>
            <div *ngIf="!options?.edit" class="form-control-plaintext">
              {{ entity.firmware }}
            </div>
            <div *ngIf="options?.edit && (available.firmware | async)">
              <ng-select
                placeholder="Select Firmware"
                [items]="firmware_list"
                bindLabel="label"
                bindValue="value"
                [(ngModel)]="entity.firmware"
                (change)="onChange($event)"
                class="w-100"
              ></ng-select>
            </div>
          </div>

          <!-- Owner -->
          <div class="mb-3 d-flex align-items-center">
            <label class="font-weight-bold mr-2 mb-0">Owner:</label>
            <div class="form-control-plaintext mb-0">{{ entity.owner }}</div>
          </div>

          <!-- Description -->
          <div class="mb-3">
            <label class="font-weight-bold">Description</label>
            <div *ngIf="!options?.edit" class="form-control-plaintext">
              {{ entity.description }}
            </div>
            <textarea
              *ngIf="options?.edit"
              class="form-control"
              rows="3"
              [(ngModel)]="entity.description"
              (ngModelChange)="updateDefinition()"
            ></textarea>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label class="font-weight-bold">Notes</label>
            <div *ngIf="!options?.edit" class="form-control-plaintext">
              {{ entity.notes }}
            </div>
            <textarea
              *ngIf="options?.edit"
              class="form-control"
              rows="3"
              [(ngModel)]="entity.notes"
              (ngModelChange)="updateDefinition()"
            ></textarea>
          </div>

          <!-- Criteria Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h5 class="mb-0 font-weight-bold">Criteria</h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <label class="font-weight-bold">Criteria Type</label>
                <ng-select
                  placeholder="Select Criteria"
                  [items]="criteria_types"
                  [(ngModel)]="entity.target.type"
                  bindLabel="label"
                  bindValue="value"
                  (ngModelChange)="onChangeCriteria($event)"
                  class="w-100"
                ></ng-select>
              </div>

              <!-- Conditional Constraints -->
              <div *ngIf="entity.target.type">
                <div
                  *ngIf="entity.target.typeHasConstraint('series')"
                  class="mb-3"
                >
                  <label class="font-weight-bold">Series</label>
                  <ng-select
                    [items]="available.series"
                    placeholder="Select Series"
                    bindLabel="label"
                    bindValue="value"
                    [(ngModel)]="entity.target.constraints.series"
                    (ngModelChange)="refreshFirmwareSeries($event)"
                  ></ng-select>
                </div>

                <div
                  *ngIf="entity.target.typeHasConstraint('manufacturer')"
                  class="mb-3"
                >
                  <label class="font-weight-bold">Manufacturer</label>
                  <ng-select
                    [items]="manufacturerSelectOptions"
                    placeholder="Select Manufacturer"
                    bindLabel="label"
                    bindValue="value"
                    [(ngModel)]="entity.target.constraints.manufacturer"
                    (ngModelChange)="refreshFirmwareManufacturer($event)"
                  ></ng-select>
                </div>

                <div
                  *ngIf="entity.target.typeHasConstraint('gateway')"
                  class="mb-3"
                >
                  <label class="font-weight-bold">Gateway</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="entity.target.constraints.gateway"
                    (ngModelChange)="updateDefinition()"
                  />
                </div>

                <div
                  *ngIf="entity.target.typeHasConstraint('appengine')"
                  class="mb-3"
                >
                  <label class="font-weight-bold">Appengine Device</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="entity.target.constraints.appengine"
                    (ngModelChange)="updateDefinition()"
                  />
                </div>

                <div
                  *ngIf="entity.target.typeHasConstraint('type')"
                  class="mb-3"
                >
                  <label class="font-weight-bold">Device Type</label>
                  <ng-select
                    [items]="available.types | async"
                    placeholder="Select Device Type"
                    bindLabel="label"
                    bindValue="value"
                    [(ngModel)]="entity.target.constraints.type"
                  ></ng-select>
                </div>

                <div
                  *ngIf="entity.target.typeHasConstraint('batch')"
                  class="mb-3"
                >
                  <label class="font-weight-bold">Batch</label>
                  <ng-select
                    [items]="available.batches | async"
                    placeholder="Select Batch"
                    bindLabel="label"
                    bindValue="value"
                    [(ngModel)]="entity.target.constraints.batch"
                  ></ng-select>
                </div>

                <div
                  *ngIf="entity.target.typeHasConstraint('range')"
                  class="mb-3"
                >
                  <label class="font-weight-bold">Range</label>
                  <div class="d-flex align-items-center">
                    <input
                      type="text"
                      class="form-control me-2"
                      style="max-width: 120px;"
                      [(ngModel)]="entity.target.constraints.range_from"
                      (ngModelChange)="updateDefinition()"
                    />
                    <span class="mx-2">to</span>
                    <input
                      type="text"
                      class="form-control ms-2"
                      style="max-width: 120px;"
                      [(ngModel)]="entity.target.constraints.range_to"
                      (ngModelChange)="updateDefinition()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer bg-light">
        <button
          *ngIf="
            currentModal?.approval &&
            entity.status != 'approved' &&
            !entity.approval
          "
          type="button"
          class="btn btn-outline-primary"
          (click)="currentModal?.approve()"
          data-dismiss="modal"
        >
          {{ currentModal?.approval }}
        </button>
        <button
          *ngIf="
            currentModal?.final_approval &&
            entity.status != 'approved' &&
            entity.approval &&
            !entity.finalization
          "
          type="button"
          class="btn btn-outline-primary"
          (click)="currentModal?.finalApprove()"
          data-dismiss="modal"
        >
          {{ currentModal?.final_approval }}
        </button>
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-outline-danger"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.revertMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.revert()"
          data-dismiss="modal"
        >
          {{ currentModal?.revertMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg && entity?.pending"
          type="button"
          class="btn btn-primary"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>

    <!-- Pop-Up Menu -->
    <ng-template #linkModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ currentModal.title }}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="currentModal?.cancel()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="currentModal.form == 'delete-link'">
          <div class="row mb-2">
            <div class="col">
              <div class="alert alert-danger">Delete Link?</div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <widget-embed
                [entity]="entity"
                [layout]="'sidebar'"
                [options]="{}"
              ></widget-embed>
            </div>
          </div>
        </div>

        <div *ngIf="currentModal.form == 'save-changes'">
          <div class="row mb-2" *ngIf="entity?.pending">
            <div class="col-12">
              <div class="alert alert-danger">
                Caution: Saving changes to a firmware link will clear its
                approval flag, once cleared firmware will downgrade to the
                previous next highest weight link.
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="currentModal.form == 'approve-link'">
          <div class="row mb-2">
            <div class="col">
              <div class="alert alert-danger">Approve Firmware Link?</div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <span
                ><strong>Approval Note: </strong
                ><span>
                  <textarea
                    [(ngModel)]="currentModal.approvalMessage"
                    class="form-control"
                    rows="4"
                    placeholder="Required Comment"
                  ></textarea></span
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-warning"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg"
          type="button"
          class="btn btn-danger"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>
  